import type { JSX } from "react";
import { DropsButton, IconButton } from "shared/components/Spor";
import { TextTooltip } from "shared/components/TextTooltip";
import { DropsButtonProps } from "shared/components/drops/DropsButton";
import { FCWC } from "shared/utils/FCWC";
import { hideOnWidthClassname } from "shared/utils/hideOnWidth";

type ResponsiveButtonProps = {
  /** Breakpoint width in pixels where button switches from full to icon-only */
  variant: "primary" | "secondary" | "tertiary" | "ghost" | "floating";
  breakpoint: number;
} & DropsButtonProps;

/**
 * Listens to the width of `container` and collapses
 * to an icon button if the width is below `breakpoint`
 *
 * You must add `generateResponsiveButtonStyles` to the container
 */
export const ResponsiveButton: FCWC<ResponsiveButtonProps> = ({
  children,
  breakpoint,
  ...props
}) => {
  const { spinner, ...iconProps } = props;
  return (
    <>
      <DropsButton
        {...props}
        className={hideOnWidthClassname("hide-on-small", breakpoint)}
      >
        {children}
      </DropsButton>
      <TextTooltip label={children} showArrow>
        <IconButton
          {...iconProps}
          icon={(props.leftIcon ?? props.rightIcon) as JSX.Element | undefined}
          aria-label={children as string}
          className={hideOnWidthClassname("hide-on-large", breakpoint)}
        />
      </TextTooltip>
    </>
  );
};
